import { Grid, Typography, Divider, Box, Paper, Button } from "@mui/material";
import { useIntl } from "react-intl";
import { Spinner } from "react-bootstrap";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DinamicTable from "components/DinamicTable/DinamicTable";

interface Requisiciones {
  id: number;
  estatus: number;
}

interface DetalleInventarioProps {
  verRequisiciones?: Requisiciones[] | null;
  requisicionesPaginadas: Requisiciones[];
  visualizacion: string | null;
  handleVisualizacion: (
    event: React.MouseEvent<HTMLElement>,
    nuevaVisualizacion: string | null
  ) => void;
  page: number;
  rowsPerPage: number;
  handleChangePage: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  buscador: string;
  handleBuscadorChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleisAlertCrearRequisicionOpen: () => void;
  procesando: boolean;
  handleisAlertOpenDetalleRequisicion: () => void;
  setVerDetalleRequisicion: React.Dispatch<React.SetStateAction<any>>;
  getJefeInmediato: (datos: any) => Promise<void>;
  getBitacoraRequisicionPorId: (datos: any) => Promise<void>;
  handleisAlertOpenBitacora: () => void;
  getRequisicionPorId: (datos: any) => Promise<void>;
}

const RequisicionModulo = ({
  verRequisiciones,
  requisicionesPaginadas,
  visualizacion,
  handleVisualizacion,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  buscador,
  handleBuscadorChange,
  handleisAlertCrearRequisicionOpen,
  procesando,
  handleisAlertOpenDetalleRequisicion,
  setVerDetalleRequisicion,
  getJefeInmediato,
  getBitacoraRequisicionPorId,
  handleisAlertOpenBitacora,
  getRequisicionPorId
}: DetalleInventarioProps) => {
  if (!verRequisiciones) return null;
  const intl = useIntl();

  const getEstado = (estado: number) => {
    switch (estado) {
      case 1:
        return "success";
      case 0:
        return "error";
      default:
        return "default";
    }
  };

  const estadosMap: { [key: number]: string } = {
    1: "ACTIVADO",
    0: "DESACTIVADO",
  };

  const traducirEstado = (estado: number | null): string => {
    if (estado === null || estado === undefined) return "SIN ESTADO";
    return estadosMap[estado] ?? "SIN ESTADO";
  };

  return (
    <Box sx={{ px: 2, pb: 2, mt: 3 }}>
      <Grid container spacing={3}>
        {/* Información de la talla */}
        <Grid item xs={12}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Grid container>
              <Grid item xs={12} md={10}>
                <Typography
                  variant="h6"
                  color="primary"
                  gutterBottom
                  sx={{ color: "#07177d", textAlign: { xs: "center", sm: "left" } }}
                >
                  Requisiciones registradas
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={2}
                sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                <Button
                  sx={{ color: "#fff", background: "#041d45" }}
                  variant="contained"
                  endIcon={<AddBoxIcon />}
                  onClick={(e: any) => {
                    handleisAlertCrearRequisicionOpen();
                  }}
                >
                  {intl.formatMessage({ id: "nueva_requisicion" })}
                </Button>
              </Grid>
            </Grid>
            <Divider sx={{ m: 2 }} />
            {verRequisiciones.length > 0 ? (
              <>
                <DinamicTable
                  key={"tabla"}
                  sinExport
                  canSearch
                  columnsOrder={[
                    "folio",
                    "nombre_creador",
                    "nombre_usuario",
                    "nombre_empresa",
                    "computo",
                    "detalles",
                    "created_at",
                    "estatus_requisicion",
                  ]}
                  data={verRequisiciones}
                  esListaRequisicion
                  actions
                  enAccion={(accion, row) => {
                    if (accion === "ver") {
                      const datos = {
                        id_usuario_creador: row?.id_creador,
                        id_requisicion: row?.id,
                      };
                      getRequisicionPorId(datos);
                      getJefeInmediato(datos);
                      handleisAlertOpenDetalleRequisicion();
                    }
                    if (accion === "ver_bitacora") {
                      const datos = {
                        id_requisicion: row?.id,
                      };
                      getRequisicionPorId(datos)
                      getBitacoraRequisicionPorId(datos);
                      handleisAlertOpenBitacora();
                    }
                  }}
                />
              </>
            ) : procesando ? (
              <Box sx={{ textAlign: "center", py: 4 }}>
                <Typography variant="h6" color="text.secondary">
                  {intl.formatMessage({ id: "general_cargando_datos" })}
                </Typography>
                <Spinner animation="border" />
              </Box>
            ) : verRequisiciones?.length === 0 && !procesando ? (
              <Box sx={{ textAlign: "center", py: 2 }}>
                <Typography variant="h6" color="text.secondary">
                  {intl.formatMessage({ id: "no_hay_datos_registrados" })}
                </Typography>
              </Box>
            ) : null}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
export default RequisicionModulo;
